module.exports = __webpack_public_path__ + "img/logo-firma.04da2499.png";